module.exports = __webpack_public_path__ + "static/media/axe-battle.a96d1ae3.svg";